module.exports = ":host {\n  display: block;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/examples/multi-selection/multi-selection.component.css
// module id = ./src/app/examples/multi-selection/multi-selection.component.css
// module chunks = main